const PageContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="max-w-[1304px] mx-auto p-6 sm:p-8 min-h-full">
      {children}
    </div>
  );
};

export default PageContent;
